var image_upload_default = {
  "container": "_3ubvO",
  "disabled": "oaOKy",
  "imageInput": "qrTDb",
  "overlay": "a4kuK",
  "text": "GKYKi",
  "shown": "YhRbp",
  "hide": "M0XjM",
  "spinner": "NHTqt",
  "spin": "B3oCf"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
